import { NodeEdgeMapper } from '@iotv/datamodel-core';
import { objectsMatchByHash } from '@iotv/iotv-v3-types';
import { useEffect, useState } from 'react';
import { getEntityNetworkQuery } from '..';
import Assembler from '../../../data/Assembler';
import { ConsumerDao } from '../../../data/ConsumerDAO';
const debug = process.env.REACT_APP_DEBUG && false;
export const useEntityNetwork = ({ entityNetwork: entityNetworkIn, applicationData, UserFunctions, fetch = true, }) => {
    /** instantiated network */
    const entityNetwork = entityNetworkIn ? (Assembler.getInstance(entityNetworkIn) ?? entityNetworkIn) : null;
    const [querying, setQuerying] = useState(false);
    /** whether we're loading the network from the datastore */
    const loading = entityNetwork === null || applicationData === undefined || querying;
    /** all the VOBs (with edges) that are included in the network */
    const [data, setData] = useState([]);
    /** all the VOBs that are included in the network, linked by their edges */
    const nem = new NodeEdgeMapper();
    nem.loadItems(data);
    // query the datastore with a constructed branching query to fetch all entities in the network and all edges between them that are part of the network
    // and load the results into state
    useEffect(() => {
        if (!entityNetwork || !fetch)
            return;
        setQuerying(true);
        debug && console.log('useEntityNetwork', 'querying datastore for entity network', entityNetwork.sk);
        ConsumerDao.getGraphQueryRequestV2({ contextObjects: [entityNetwork], query: getEntityNetworkQuery(entityNetwork.type) }).then(({ err, data }) => {
            setQuerying(false);
            if (err || !data)
                return;
            const newData = data.getContainedNodesAndEdges();
            UserFunctions.addObjectsToState(newData);
            debug && console.log('useEntityNetwork', 'added entity network to state', entityNetwork.sk);
        });
    }, [entityNetwork?.sk, fetch]);
    // query state with a constructed branching query to fetch all entities in the network and all edges between them that are part of the network
    // and load the results into this component (filtering out any edges to the entity network itself)
    useEffect(() => {
        if (!entityNetwork || !applicationData)
            return;
        debug && console.log('useEntityNetwork', 'querying state for entity network', entityNetwork.sk);
        const queryNEM = applicationData.applyBranchingQuery([entityNetwork], getEntityNetworkQuery(entityNetwork.type));
        const newData = [...queryNEM.getContainedItems(), ...queryNEM.getContainedEdges()].filter((v) => !v.pk.startsWith(entityNetwork.type));
        debug && console.log('useEntityNetwork', 'got data from state');
        if (objectsMatchByHash(data, newData))
            return;
        debug && console.log('useEntityNetwork', 'data is new, updating schematic');
        setData(newData);
    }, [applicationData, entityNetwork?.sk]);
    return { entityNetwork, nem, loading };
};
